import { makeStyles } from '@material-ui/core/styles';
import BottomActionBGImage from '@assets/overview-bottomaction-bg.svg';
const useStyles = makeStyles(({ variables, breakpoints }) => ({
  bottomActionContent:{
    ['&.fix-treshold']: {
      position:'inherit',
    },
    position:'fixed',
    zIndex:1,
    width:'100%',
    height:'86px',
    bottom:variables?.spacingNone,
    display:'flex',
    alignItems:'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor:'rgba(255, 255, 255, 0.55)',
    paddingLeft:variables?.spacingG,
    paddingRight:variables?.spacingG,
    [breakpoints.down('xs')]: {
      height:'63px',
      paddingLeft:variables?.spacingD,
      paddingRight:variables?.spacingD,
    },
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto',
    backgroundPosition:'center',
    background:`url(${BottomActionBGImage})`,
    backgroundBlendMode:'lighten',
    '& .bottom-action-content-text':{
    },
    '& .bottom-action-content-cta':{
      '& .jetButton': {
        width:'276px',
        [breakpoints.down('xs')]: {
          maxWidth:'180px'
        }
      }
    },
    '& .bottom-action-content-store-link-container':{
      '& img':{ 
        marginRight:variables?.spacingA,
        cursor:'pointer'
      }
    }
  }
}));

export default useStyles;
